import { Button } from "@/components/ui/button";
import { Download } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Label } from "@/components/ui/label";

interface DownloadOptionsProps {
  onDownload: (includeAnnotations: boolean, quality: number) => void;
}

export const DownloadOptions = ({ onDownload }: DownloadOptionsProps) => {
  return (
    <div className="space-y-4">
      <h3 className="font-medium text-sm">Export</h3>

      <div className="space-y-2">
        <Button
          variant="outline"
          size="sm"
          className="w-full"
          onClick={() => onDownload(true, 0.95)}
        >
          <Download className="w-4 h-4 mr-2" />
          Download with Edits (High Quality)
        </Button>

        <Button
          variant="outline"
          size="sm"
          className="w-full"
          onClick={() => onDownload(true, 0.8)}
        >
          <Download className="w-4 h-4 mr-2" />
          Download with Edits (Standard)
        </Button>

        <Button
          variant="outline"
          size="sm"
          className="w-full"
          onClick={() => onDownload(false, 1.0)}
        >
          <Download className="w-4 h-4 mr-2" />
          Download Original
        </Button>
      </div>
    </div>
  );
};
